import React from 'react'
import { Query } from 'react-apollo'
import RouteAdminClipFeedbackIndexQuery from './index.query'
import PageLoader from 'components/PageLoader'
import { Table } from 'stylist'
import { friendlyDateTime } from 'utils/time'
import { formatTime } from 'utils/time'

const RouteAdminClipFeedbackIndex = () => (
  <Query query={RouteAdminClipFeedbackIndexQuery}>
    {({ loading, data: { clipFeedbacks } = [] }) =>
      loading ? (
        <PageLoader />
      ) : (
        <Table data={clipFeedbacks.edges.map(edge => edge.node)}>
          <Table.Row>
            <Table.Column
              label="Created at"
              render={({ insertedAt }) => friendlyDateTime(insertedAt)}
            />
            <Table.Column
              label="Start Time"
              render={({ clip: { startTime } }) => formatTime(startTime)}
            />
            <Table.Column
              label="Feedback"
              render={({ positive }) => (positive ? 'Positive' : 'Negative')}
            />

            <Table.Column dataKey="text" label="Text" />
            <Table.Column
              label="User"
              render={({ user: { email } }) => email}
            />

            <Table.Column
              label="Video Title"
              render={({
                clip: {
                  video: { title }
                }
              }) => title}
            />
          </Table.Row>
        </Table>
      )
    }
  </Query>
)

export default RouteAdminClipFeedbackIndex



// WEBPACK FOOTER //
// ./src/routes/admin/feedback/clip_feedback/index.js